export default __webpack_public_path__ + "assets/images/8ba0bd7ce97f0e0d50a65c68988efb9b.png";